<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4" v-show="!showSkeleton">
      <div class="text-h4 mb-4">Atualizar Grupo - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroGrupoRotas edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import grupoDeRotasStore from '../_store'

import CadastroGrupoRotas from './CadastroGrupoDeRotas'

export default {
  props: {
    _id: String,
  },

  components: { SkeletonLoaderTitleUpdate, CadastroGrupoRotas },

  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarGrupoDeRotasModulePABXStore', ['getSpecificGrupoDeRotas']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarGrupoDeRotasModulePABXStore', grupoDeRotasStore)

    await this.listarGrupoDeRotasEspecifico(this._id)
    this.description = this.getSpecificGrupoDeRotas.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarGrupoDeRotasModulePABXStore', ['listarGrupoDeRotasEspecifico']),
  },
}
</script>